export function getHSDescriptionByID(axiosPrivate, params) {
  const id = params.idHS
  return axiosPrivate.get(`/master-data/hs-description/get-hs-description-by-id/${id}`)
}

export function createHSDescription(axiosPrivate, formData) {
  return axiosPrivate.post('/master-data/hs-description/store-hs-description', formData)
}

export function updateHSDescriptionById(axiosPrivate, id, formData) {
  return axiosPrivate.put(`/master-data/hs-description/update-hs-description/${id}`, formData)
}

export function createHSCode(axiosPrivate, id, formData) {
  return axiosPrivate.post(`/master-data/store-hs-code/${id}`, formData)
}

export function deleteHSCode(axiosPrivate, id) {
  return axiosPrivate.delete(`/master-data/delete-hs-code/${id}`)
}

export function getAllHSDescriptionParent(axiosPrivate, params) {
  return axiosPrivate.get('/master-data/hs-description/all-parent', { params })
}